import SlideOutButton from "../common/SlideOutButton";
import useReprintAccepted from "../requests/useReprintAccepted";

interface ReprintAcceptButtonProps {
  stagedOrderId: string;
}

const ReprintAcceptButton = ({ stagedOrderId }: ReprintAcceptButtonProps) => {
  const reprintAccepted = useReprintAccepted(stagedOrderId);

  return <SlideOutButton text="Accept Reprint" onClick={() => reprintAccepted.request({ success: true })} />;
}

export default ReprintAcceptButton;
